import dva from 'dva'
import router from './router'
import LoginModel from './models/login'
import ClientModel from './models/client'
import HotelModel from './models/hotel'
import ManagerModel from './models/manager'
import RecepcionistModel from './models/recepcionist'
import InvoiceModel from './models/invoice'
import UserModel from './models/user'
import ExpenseTypeModel from './models/expenseType'
import PaymentTypeModel from './models/paymentType'
import AdonTypeModel from './models/adonType'
import EmployeeModel from './models/employee'
import IncomeModel from './models/income'
import BoucherAdonModel from './models/boucherAdon'

// 1. Initialize
const app = dva()

// 2. Model
app.model(LoginModel)
app.model(ClientModel)
app.model(HotelModel)
app.model(ManagerModel)
app.model(RecepcionistModel)
app.model(InvoiceModel)
app.model(UserModel)

app.model(ExpenseTypeModel)
app.model(PaymentTypeModel)
app.model(AdonTypeModel)
app.model(EmployeeModel)

app.model(IncomeModel)
app.model(BoucherAdonModel)

// 3. Router
app.router(router);

// 4. Start
app.start('#root')


// WEBPACK FOOTER //
// ./src/index.js